import React from 'react';
import {
    SimpleForm,
    TextInput,
    SelectInput,
    DisabledInput,
} from 'react-admin';
import validateForm from './validation';
import { useTranslation } from 'react-i18next';

const typeChoices = [
    { id: 'string', name: 'String' },
    { id: 'numeric', name: 'Numeric' },
    { id: 'date', name: 'Date' },
];

const AttributeForm = (props) => {
    const { t } = useTranslation();
    const isEdit = props.record && props.record.id;

    return (
        <SimpleForm {...props} redirect={'/attributes'} validate={validateForm}>
            <TextInput
                source={'name'}
                label={t('Name')}
                autoFocus
                fullWidth
            />

            {isEdit ? (
                <DisabledInput
                    source={'slug'}
                    label={t('Slug')}
                    fullWidth
                    helperText={t('URL-friendly identifier (cannot be changed after creation)')}
                />
            ) : (
                <TextInput
                    source={'slug'}
                    label={t('Slug')}
                    fullWidth
                    helperText={t('URL-friendly identifier (lowercase letters, numbers, and hyphens only - cannot be changed after creation)')}
                />
            )}

            {isEdit ? (
                <DisabledInput
                    source={'type'}
                    label={t('Type')}
                    fullWidth
                    helperText={t('Attribute type cannot be changed after creation')}
                />
            ) : (
                <SelectInput
                    source={'type'}
                    label={t('Type')}
                    choices={typeChoices}
                    defaultValue={'string'}
                    fullWidth
                    helperText={t('Determines how values are validated and compared (cannot be changed after creation)')}
                />
            )}
        </SimpleForm>
    );
};

const TranslatedAttributeForm = (props) => {
    const { t } = useTranslation();
    return <AttributeForm t={t} {...props} />;
};

export default TranslatedAttributeForm;